<div class="row padding-top-10 text-center" style="margin-bottom:15px;">
  <hr class="col-sm-4 padding-0 hr-style"><h4 class="col-sm-4.5">Plant SCADA/Citect License Generator</h4><hr class="hr-style col-sm-3 padding-0">
</div>

<div class="row">

  <div class="col-md-12 ">
    <ul class="nav nav-tabs" role="tablist">
      <li class="nav-item col-md-2 col-sm-6 col-xs-6 padding-0" role="presentation" [ngClass]="{'active':activeTab == 'LicenseGenerator'}">
        <a class="nav-link cursor" aria-controls="license-generator-form" role="tab" data-toggle="tab" (click)="onTabSelectionChanged('LicenseGenerator')">License Generator</a>
      </li>
      <li class="nav-item col-md-2 col-sm-6 col-xs-6 padding-0" role="presentation" [ngClass]="{'active':activeTab == 'Help'}">
        <a class="nav-link cursor" aria-controls="license-generator-help" role="tab" data-toggle="tab" (click)="onTabSelectionChanged('Help')">Help</a>
      </li>
      <li class="nav-item col-md-2 col-sm-6 col-xs-6 padding-0" role="presentation" [ngClass]="{'active':activeTab == 'CiUSafe'}">
        <a class="nav-link cursor" aria-controls="license-generator-ciusafe" role="tab" data-toggle="tab" (click)="onTabSelectionChanged('CiUSafe')">CiUSafe Downloads</a>
      </li>
      <li class="nav-item col-md-4 col-sm-6 col-xs-6 padding-0" role="presentation" [ngClass]="{'active':activeTab == 'FloatingLicenseManager'}">
        <a class="nav-link cursor" aria-controls="license-generator-flm" role="tab" data-toggle="tab" (click)="onTabSelectionChanged('FloatingLicenseManager')">Floating License Manager Downloads</a>
      </li>
    </ul>

    <div class="tab-content">
      <div></div>
      <div role="tabpanel" class="tab-pane" [ngClass]="{'active':activeTab == 'LicenseGenerator'}" id="license-generator-form">
        <div *ngIf="licenseSummary?.errorMessage != null || licenseSummary?.errorMessage?.length > 0">
          <div class="alert alert-notice alert-dismissible fade show" role="alert">
            <a class="close float-right cit-alert-margin" (click)="licenseSummary.errorMessage=null" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </a>
            <h4>Notice:</h4>
            {{licenseSummary?.errorMessage}}
          </div>
          <!-- <ng-container  *ngTemplateOutlet="alertNotice;context:{ $implicit: licenseSummary?.errorMessage , type: 'error'}"></ng-container> -->
        </div>
        <div *ngIf="licenseSummary?.upgradeAPIError != null">
          <div class="alert alert-notice alert-dismissible fade show" role="alert">
            <a class="close float-right cit-alert-margin" (click)="licenseSummary.upgradeAPIError=null" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </a>
            <h4>Notice:</h4>
            {{licenseSummary?.upgradeAPIError?.Message}}
          </div>
        </div>
        <div *ngIf="citEmailContext != null">
          <div class="alert alert-notice alert-dismissible fade show" role="alert">
            <a class="close float-right cit-alert-margin" (click)="citEmailContext=null" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </a>
            <h4>Notice:</h4>
            {{citEmailContext?.details}}
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <div id="accordion">


              <div class="card">

                <div class="card-header content-header cursor" data-toggle="collapse" data-target="#licenseGeneratorForm" aria-expanded="true">License Generator Form </div>
                <div id="licenseGeneratorForm" data-parent="#accordion" class="collapse show">
                  <div class="card-body">
                    <form [formGroup]="submissionForm" (ngSubmit)="onSubmit()">
                      <label>AVEVA Enterprise Licensing</label><br>
                      <button type="button" class="btn btn-primary" (click)="getLicensesPage()" style="background-color:#4e047b ">Offline Activation</button> <br>

                      <!--<p>Please enter your key serial number to generate your Authcode</p>
                      <p>Please enter your key serial number or activation id to generate your AuthCode</p>
                      <div class="form-group">
                        <label>USB Key serial number</label>
                        <div class="form-row">
                          <div>
                            <select class="form-control lic-gen-form-control" formControlName="usbSerialPrefix">
                              <option *ngFor="let option of usbSerialPrefixOptions" [value]="option.value">{{option.displayValue}}</option>
                            </select>
                          </div>
                          <div style="padding:6px;">
                            &nbsp;-&nbsp;
                          </div>
                          <div>
                            <input style="padding: 17px 0px;" class="form-control lic-gen-form-control" formControlName="usbSerialSuffix" minlength="5" maxlength="5" OnlyNumber="true" />
                          </div>
                          <div>
                            &nbsp;&nbsp;
                            <button type="submit" class="btn btn-submit" [disabled]="disableUSBSubmitButton">Submit</button>
                          </div>
                        </div>
                      </div>-->
                      <!--<hr>-->
                      <!--<p>
                        OR
                      </p>-->
                      <!--<div class="form-group">
                        <p style="margin-bottom: 5px;">
                          Software key
                        </p>
                        <p>Plant SCADA 2020R2 (v8.3) and older Software Licenses</p>


                        <div>
                        <small>
                        Legacy Schneider Electric Floating License Manager</small>
                        <div class="form-row">
                          <div><input class="form-control lic-gen-form-control-ext" (ngModelChange)="mychange($event)" formControlName="activationId" [ngModel]="iban_no" minlength="16" maxlength="16" /></div>
                          &nbsp;&nbsp;
                          <div><button type="submit" class="btn btn-submit" [disabled]="disableFLMSoftKeySubmitButton" style="border:none">Submit</button></div>
                        </div>

                          <small>(Format: <strong>X-XXXX-XXXX-XXXX</strong>)</small>
                          <div *ngIf="submissionForm.controls['activationId'].errors && !submissionForm.controls['activationId'].pristine" class="error-msg">

                            <small [hidden]="submissionForm.controls['activationId'].valid">Please enter 13 digit activation id</small>
                          </div>
                        </div>
                      </div>-->
                      <!--<hr>-->
                      <div class="container" style="margin-left:100px; margin-top:100px">
                        <div class="row">
                          <div class="col-12 order-1 d-lg-none">
                            <div class="logo-img">
                              <img src="https://www.aveva.com/content/experience-fragments/aveva/en/site/header-2/master/_jcr_content/root/responsivegrid/globalheader/logo.coreimg.svg/1655394323761/header-logo.svg"
                                   alt="Aveva">
                            </div>
                          </div>
                          <div class="col-12 order-3 col-lg-7 order-lg-1">
                            <div class="logo-img d-none d-lg-block">
                              <img src="https://www.aveva.com/content/experience-fragments/aveva/en/site/header-2/master/_jcr_content/root/responsivegrid/globalheader/logo.coreimg.svg/1655394323761/header-logo.svg"
                                   alt="Aveva">
                            </div>

                            <h1 class="maintenance-text-heading">Alert: Maintenance in progress</h1>
                            <p class="maintenance-text">
                              The Plant SCADA (Citect) USB License Generator site is currently undergoing maintenance.
                            </p>

                            <p>
                              For USB License Authorization Codes or License Details, please reach out to your local Distributor for assistance.
                            </p>
                            <br>

                          </div>
                          <div class="col-12 order-2 col-lg-5 order-lg-2 text-center">
                            <img class="img-align" src="./assets/maintainance/images/maintenance_image.png" alt="maintenance_image">
                          </div>

                        </div>
                      </div>

                      <!--<hr />-->

                      <div class="form-group" style="margin-top:50px">
                        <label>For Plant SCADA (Citect SCADA) software license version upgrades, Please contact the local AVEVA Distributor or AVEVA Sales Account Manager.</label>
                      </div>

                    </form>
                  </div>
                </div>
              </div>
              <!--<div class="container" style="margin-left:100px; margin-top:100px">
                <div class="row">
                  <div class="col-12 order-1 d-lg-none">
                    <div class="logo-img">
                      <img src="https://www.aveva.com/content/experience-fragments/aveva/en/site/header-2/master/_jcr_content/root/responsivegrid/globalheader/logo.coreimg.svg/1655394323761/header-logo.svg"
                           alt="Aveva">
                    </div>
                  </div>
                  <div class="col-12 order-3 col-lg-6 order-lg-1">
                    <div class="logo-img d-none d-lg-block">
                      <img src="https://www.aveva.com/content/experience-fragments/aveva/en/site/header-2/master/_jcr_content/root/responsivegrid/globalheader/logo.coreimg.svg/1655394323761/header-logo.svg"
                           alt="Aveva">
                    </div>

                    <h1 class="maintenance-text-heading">Alert: Maintenance in Progress</h1>
                    <p class="maintenance-text">
                      The Plant SCADA (Citect) License Generator site is currently undergoing maintenance.
                    </p>

                    <p>
                      For USB License Authorization Codes or License Details, please reach out to your local Distributor for assistance.
                    </p>
                    <br>

                  </div>
                  <div class="col-12 order-2 col-lg-6 order-lg-2 text-center">
                    <img class="img-align" src="./assets/maintainance/images/maintenance_image.png" alt="maintenance_image">
                  </div>

                </div>
              </div>-->
              <div class="card" style="margin-top: 10px;" *ngIf="licenseSummary != null && !isEmptyObject(licenseSummary) && licenseSummary.errorMessage == null">
                <div class="card-header content-header cursor" data-toggle="collapse" data-target="#licenseGeneratorResult" aria-expanded="true">Results</div>
                <div id="licenseGeneratorResult" class="collapse show" data-parent="#accordion">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-md-6">
                        <h2>Your key details</h2>
                        <hr>
                        <div class="col-sm-12 form-container" *ngIf="licenseSummary?.keySerialNumber != null" style="margin-bottom:10px;">
                          <div class="form-label">Key serial number</div>
                          <div class="form-field">{{licenseSummary?.keySerialNumber}}</div>
                        </div>
                        <div class="col-sm-12 form-container" *ngIf="licenseSummary?.activationId != null" style="margin-bottom:10px;">
                          <div class="form-label">Activation ID</div>
                          <div class="form-field">{{licenseSummary?.activationId}}</div>
                        </div>
                        <div class="col-sm-12 form-container" *ngIf="licenseSummary?.siteId != null" style="margin-bottom:10px;">
                          <div class="form-label">Site ID</div>
                          <div class="form-field">{{licenseSummary?.siteId}}</div>
                        </div>
                        <div class="col-sm-12 form-container" *ngIf="licenseSummary?.siteDetails?.Status != null" style="margin-bottom:10px;">
                          <div class="form-label">Status <img class="pull-right citect-info-icon" title="{{tooltipData?.status}}" src="{{assetPathVar}}/images/information.svg" /> </div>
                          <div class="form-field">{{licenseSummary?.siteDetails?.Status}}</div>
                        </div>
                        <div class="col-sm-12 form-container" *ngIf="licenseSummary?.siteDetails?.TimeLimitedStartDate != null" style="margin-bottom:10px;">
                          <div class="form-label">Time Limited Start <img class="pull-right citect-info-icon" title="{{tooltipData?.timelimitedstart}}" src="{{assetPathVar}}/images/information.svg" /></div>
                          <div class="form-field">{{licenseSummary?.siteDetails?.TimeLimitedStartDate | date:'mediumDate'}}</div>
                        </div>
                        <div class="col-sm-12 form-container" *ngIf="licenseSummary?.siteDetails?.TimeLimitedEndDate != null" style="margin-bottom:10px;">
                          <div class="form-label">Time Limited End <img class="pull-right citect-info-icon" title="{{tooltipData?.timelimitedend}}" src="{{assetPathVar}}/images/information.svg" /></div>
                          <div class="form-field">{{licenseSummary?.siteDetails?.TimeLimitedEndDate | date:'mediumDate'}}</div>
                        </div>
                        <div class="col-sm-12 form-container" *ngIf="licenseSummary?.siteDetails?.UpgradeExpiryDate != null" style="margin-bottom:10px;">
                          <div class="form-label">Upgrade Expiry <img class="pull-right citect-info-icon" title="{{tooltipData?.updateexpiry}}" src="{{assetPathVar}}/images/information.svg" /> </div>
                          <div class="form-field">{{licenseSummary?.siteDetails?.UpgradeExpiryDate | date:'mediumDate'}}</div>
                        </div>
                        <div class="col-sm-12 form-container" *ngIf="licenseSummary?.siteDetails?.ScadaVersion != null" style="margin-bottom:10px;">
                          <div class="form-label">Version<img class="pull-right citect-info-icon" title="{{tooltipData?.scadaVersion}}" src="{{assetPathVar}}/images/information.svg" /> </div>
                          <div class="form-field">{{licenseSummary?.siteDetails?.ScadaVersion}}</div>
                        </div>

                        <div class="clearfix"></div>
                        <br>

                        <div class="col-sm-12" *ngIf="licenseSummary?.licenseSummary?.Scada != null">
                          <h3>SCADA</h3>
                          <div class="form-container" *ngFor="let item of licenseSummary?.licenseSummary?.Scada">
                            <div class="form-label">{{item.PROPERTY_NAME}}</div>
                            <div class="form-field">{{item.PROPERTY_VALUE}}</div>
                          </div>
                        </div>
                        <div class="clearfix"></div>
                        <br>

                        <div class="col-sm-12" *ngIf="licenseSummary?.licenseSummary?.Historian != null">
                          <h3>Historian</h3>
                          <div class="form-container" *ngFor="let item of licenseSummary?.licenseSummary?.Historian">
                            <div class="form-label">{{item.PROPERTY_NAME}}</div>
                            <div class="form-field">{{item.PROPERTY_VALUE}}</div>
                          </div>
                        </div>

                      </div>

                      <div class="col-md-6" *ngIf="licenseSummary?.showRequestAuthCode == false">
                        <h3>Update your key version</h3>
                        <p class="text-danger">
                          <label class="lic-update-text">
                            If you are running Vijeo Citect version 7.0, 7.10 or 7.20, please use the Vijeo authorisation code.
                            For all other versions please use the Citect authorisation codes.
                          </label>

                        </p>

                        <div class="form-group authcode-form-group" *ngIf="licenseSummary?.authCode?.AuthorizationCodeCitect == null && licenseSummary?.authCode?.AuthorizationCodeCitect == null && licenseSummary?.authCode?.AuthorizationCode != null">
                          <div class="container pt-12">
                            <label for="cit-authcode-txt" class="ml-15">Citect SCADA Authorisation Code</label>
                            <button class="btn btn-default authcode-copy-btn btn-submit ml-5" type="button" title="Copy to clipboard" (click)="copyToClipboard(citAuthcode)">Copy</button>
                          </div>
                          <textarea name="cit-authcode-txt" class="form-control" rows="5" readonly="readonly" #citAuthcode>{{licenseSummary?.authCode?.AuthorizationCode}}</textarea>
                        </div>
                        <div class="form-group authcode-form-group" *ngIf="licenseSummary?.authCode?.AuthorizationCodeCitect != null">
                          <div class="container pt-12">
                            <label for="cit-authcode-txt" class="ml-15">Citect SCADA Authorisation Code</label>
                            <button class="btn btn-default authcode-copy-btn btn-submit ml-5" type="button" title="Copy to clipboard" (click)="copyToClipboard(citAuthcode)">Copy</button>
                          </div>
                          <textarea name="cit-authcode-txt" class="form-control" rows="5" readonly="readonly" #citAuthcode>{{licenseSummary?.authCode?.AuthorizationCodeCitect}}</textarea>

                        </div>


                        <div class="form-group authcode-form-group mt-35" *ngIf="licenseSummary?.authCode?.AuthorizationCodeVijeo != null">
                          <div class="container pt-12">
                            <label for="vjc-authcode-txt" class="ml-15">Vijeo Citect Authorisation Code</label>
                            <button class="btn btn-default authcode-copy-btn btn-submit ml-32" type="button" title="Copy to clipboard" (click)="copyToClipboard(vjcAuthcode)">Copy</button>
                          </div>
                          <textarea name="vjc-authcode-txt" class="form-control" rows="5" readonly="readonly" #vjcAuthcode>{{licenseSummary?.authCode?.AuthorizationCodeVijeo}}</textarea>

                        </div>
                        <div #clipboard id="snackbar">Copied to clipboard..</div>
                        <div class="clearfix mt-35"></div>
                        OR Email to

                        <form #emailForm="ngForm" (ngSubmit)="sendEmail(); emailForm.reset();">
                          <div class="row">
                            <div class="col-sm-8">
                              <div class="form-group">
                                <input required type="email" name="email" #name="ngModel" pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,3}$" class="cit-email-input form-control" placeholder="Please enter your email" [(ngModel)]="citEmail" />
                                <div [hidden]="name.valid || name.pristine" class="error-msg">
                                  <small>Please enter valid email</small>
                                </div>
                              </div>

                            </div>
                            <button type="submit" class="col-sm-3 btn btn-submit" style="margin-left:5px;" [disabled]="!emailForm.valid" style="height:34px;">Send</button>
                          </div>
                        </form>
                      </div>


                      <!--Request upgrade-->
                      <div class="col-md-6" *ngIf="licenseSummary?.showRequestAuthCode == true && !showRequestVersionUpdate()">
                        <h3>Update your key version</h3>
                        <p>
                          <label class="lic-update-text">
                            Your key is not able to generate an AuthCode. Click the "Request AuthCode" button to send your request to AVEVA Order Management Team. We will be in contact by email within 1-2 business days.
                          </label>
                        </p>
                        <div class="clearfix"></div>
                        <div (click)="requestAuthCodeButtonClick(true)">
                          <a href="#modal-container-licenserequest" data-toggle="modal" class="hasTip anchor-style btn btn-submit">Request AuthCode</a>
                        </div>
                      </div>

                      <!--Request version upgrade-->
                      <div class="col-md-6" *ngIf="showRequestVersionUpdate()">
                        <h3>Update your key version</h3>
                        <p>
                          <label class="lic-update-text">
                            Click the "Request Version Update" button to send your request to AVEVA Order Management Team. Your new activation ID will then be sent to your contact email within 1-2 business days.
                          </label>
                        </p>
                        <div class="clearfix"></div>
                        <div (click)="requestAuthCodeButtonClick(false)">
                          <a href="#modal-container-licenserequest" data-toggle="modal" class="hasTip anchor-style btn  btn-submit">Request Version Update</a>
                        </div>
                        <br />
                        <div *ngIf="iban_no!=null && iban_no.length>0 ">

                          <div>
                            <span>
                              For more information on Software Keys, please click <a target="_blank" href="https://softwaresupport.aveva.com/LicenseGenerator/Citect/#?selectedTab=Help">here</a>
                            </span>
                          </div>
                          <br />
                          <div>
                            <span>
                              To get help with Licence Activation, contact your nearest software registration center using the details found <a target="_blank" href="https://www.se.com/ww/sites/corporate/en/support/software-licensing/contact-us">here</a>
                            </span>
                          </div>
                          <br />
                          <div>
                            <span [innerHtml]="tooltipData?.messageNote">

                            </span>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>

      <div role="tabpanel" class="tab-pane" [ngClass]="{'active':activeTab == 'Help'}" id="license-generator-help">

        <cit-help></cit-help>
      </div>

      <div role="tabpanel" class="tab-pane" [ngClass]="{'active':activeTab == 'CiUSafe'}" id="license-generator-ciusafe">
        <!-- <p align="left">
          <a title="CiUSafe 8.10.0.2086" href={{ciUSafeDownloadURL}} target="_blank">Download the latest version of CiUSafe (CiUSafe_8_10_0_2086.zip)</a> (1.07 MB)
        </p>
        <div class="checksum">
          MD5: 61B64598342A8185FFEAF7AEA24693DB<br>
          SHA1: 712AE2F950B1E807B88E57E2774911151D04FA3D
        </div>
        <p></p>
        <p align="left">
          <a title="Sentinel System Driver 7.5.9" href={{sentinelDownloadURL}} target="_blank">Download the latest Sentinel Key Drivers</a> (1.88 MB)
        </p>
        <div class="checksum">
          MD5: 1A9A549D627FFACB3EBA037E5BC7D37F<br>
          SHA1: ABDDA90ABA33451DA3E0B35FBB3356263830D48C
        </div>
        <p></p> -->
        <!-- <b>Installing a new version of CiUSafe with Citect SCADA</b>
        <ol>
          <li>Ensure the CiUSafe Utility is not running</li>
          <li>Create a backup of the “CiUSAFE.exe” and “USafe32.DLL” files located the “Bin” directory of your Citect SCADA installation folder (you may need Administrator permissions). The default folder location is shown in the below table for reference.</li>
          <li>Download the latest version of CiUSafe using the link above</li>
          <li>Extract the .zip file</li>
          <li>Locate the files “CiUSAFE.exe” and “USafe32.DLL” </li>
          <li>Copy these files to the “Bin” directory of your Citect SCADA installation folder (you may need Administrator permissions), overwriting the existing files. </li>
        </ol>         -->

        <div *ngFor="let item of ciUSafeDownloadsData" class="margin-bottom-10">
          <p align="left">
            <a title="CiUSafe" href={{item.downloadUrl}} target="_blank"> {{item.name}}</a> ({{item.size}})
          </p>
          <div class="checksum" *ngFor="let itemKey of item.keys">
            {{itemKey.key}}: {{itemKey.value}}<br>
          </div>
        </div>
        <div [innerHTML]="installationSteps"></div>
        <div>
          <table class="table table-striped table-condensed table-bordered" *ngIf="tableData?.length > 0">
            <thead>
              <tr>
                <th>Product Version</th>
                <th>Location (32-bit Windows OS)</th>
                <th>Location (64-bit Windows OS)</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of tableData">
                <td>{{item.version}}</td>
                <td>{{item.location32Bit}}</td>
                <td>{{item.location64Bit}}</td>
              </tr>
            </tbody>
          </table>
        </div>


      </div>

      <div role="tabpanel" class="tab-pane" [ngClass]="{'active':activeTab == 'FloatingLicenseManager'}" id="license-generator-flm">

        <div *ngFor="let item of floatingLicenseData" class="margin-bottom-10">
          <p align="left">
            <a title="Floating License Manager" href={{item.downloadUrl}} target="_blank">{{item.name}}</a> ({{item.size}})
          </p>
          <div class="checksum" *ngFor="let itemKey of item.keys">
            {{itemKey.key}}: {{itemKey.value}}<br>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<ng-template #alertNotice let-alertNoticeMessage let-type="type" class="simple">

  <div *ngIf="type != null" class="row">
    <div class="col-md-12">
      <!-- Dynamic Alert based on server response -->
      <div class="alert alert-notice alert-dismissible" role="alert">
        <h4>Notice</h4>
        {{alertNoticeMessage}}
        <button type="button" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
    </div>
  </div>
</ng-template>

<!-- Dialog Box -->
<div class="modal fade" id="modal-container-300584" role="dialog" aria-labelledby="myModalLabel" aria-hidden="false">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title pull-left" id="myModalLabel">
          How-to video: Software License Activation
        </h4>
        <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
      </div>
      <div class="modal-body">
        <iframe style="width:100%" width="100%" height="315" src="//www.youtube.com/embed/FVIsPzrLUjY" frameborder="0" allowfullscreen=""></iframe>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-submit" data-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>

<!-- Dialog Box for License Request Form-->
<div class="modal fade" id="modal-container-licenserequest" role="dialog" aria-labelledby="myModalLabel" aria-hidden="false">
  <div class="modal-dialog modal-md">
    <div class="modal-content">
      <div class="modal-header">
        <h3 class="modal-title float-left" id="myModalLabel" *ngIf="!showRequestVersionUpdate()">
          Generate Authcode
        </h3>
        <h3 class="modal-title float-left" id="myModalLabel" *ngIf="showRequestVersionUpdate()">
          Upgrade Version
        </h3>

        <button #closeBtn type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
      </div>
      <div class="modal-body">
        <form [formGroup]="authcodeForm" class="form-horizontal" (ngSubmit)="onSubmit()">
          <div class="form-group row" *ngIf="!showRequestVersionUpdate()">
            <label class="control-label col-sm-4">Key serial number *</label>
            <div class="col-sm-8">
              <input class="form-control lic-gen-form-control-ext" formControlName="keySerialNumber" disabled />
            </div>
          </div>
          <!-- <div class="form-group row" *ngIf="showRequestVersionUpdate()">
            <label class="control-label col-sm-4">Activation *</label>
            <div class="col-sm-8">
              <input class="form-control lic-gen-form-control-ext" formControlName="activationId" disabled />
            </div>
          </div> -->
          <div class="form-group row" *ngIf="showRequestVersionUpdate()">
            <label class="control-label col-sm-4">
              Activation Codes *
              (list additional keys here, one code per line)
            </label>
            <div class="col-sm-8">
              <textarea class="form-control lic-gen-form-control-ext" formControlName="activationId"></textarea>
            </div>
          </div>
          <div class="form-group row">
            <label class="control-label col-sm-4">Site Number *</label>
            <div class="col-sm-8">
              <input class="form-control lic-gen-form-control-ext" formControlName="siteNumber" />
            </div>
          </div>
          <div class="form-group row">
            <label class="control-label col-sm-4">Product*</label>
            <div class="col-sm-8">
              <select class="form-control select-product lic-gen-form-control-ext" formControlName="product">
                <option *ngFor="let c of productArray" [value]="c.value">{{c.displayValue}}</option>
              </select>
            </div>
          </div>
          <div class="form-group row">
            <label class="control-label col-sm-4">Contact Name *</label>
            <div class="col-sm-8">
              <input class="form-control lic-gen-form-control-ext" formControlName="contactName" />
            </div>
          </div>
          <div class="form-group row">
            <label class="control-label col-sm-4">Contact Email Address *</label>
            <div class="col-sm-8">
              <input class="form-control lic-gen-form-control-ext" formControlName="contactEmail" type="email" name="email" (keydown.space)="$event.preventDefault()" />
              <div *ngIf="authcodeForm.controls['contactEmail'].errors && !authcodeForm.controls['contactEmail'].pristine" class="error-msg">
                <small [hidden]="authcodeForm.controls['contactEmail'].valid">Email is required</small>
              </div>
            </div>
          </div>
          <div class="form-group row">
            <label class="control-label col-sm-4">Company Name *</label>
            <div class="col-sm-8">
              <input class="form-control lic-gen-form-control-ext" formControlName="companyName" />
            </div>
          </div>
          <div class="form-group row">
            <div class="col-sm-12">
              <label class="blurry-text col-sm-6">{{randomCaptchaCode}}</label>
              <label class="col-md-2" (click)="generateCaptcha()"><img class="refreshIcon" src="{{citGlobalConstantService.licenseGenearatorURL}}/Citect/assets/images/refresh.png" /></label>

            </div>
            <div class="col-sm-12" style="padding:0">
              <label class="control-label col-sm-12">Please enter the code shown above</label>
              <div class="row" style="margin:0">
                <div class="col-sm-6" style="padding-right:0">
                  <input id="captchacode" minlength="6" class="form-control lic-gen-form-control-ext" formControlName="captchaCode" /><span class="iconPosition" *ngIf="validCaptcha=='valid' && authcodeForm.controls['captchaCode'].valid"><i class="fa fa-check-circle fa-2x"></i></span>
                  <small *ngIf="validCaptcha=='invalid'" class="error-msg">Please Enter Valid Captcha</small>
                </div>

                <div class="col-sm-4"><button type="button" [disabled]="!authcodeForm.controls['captchaCode'].valid" class="btn btn-submit" (click)="validateCaptcha(authcodeForm.controls['captchaCode'].value)">Validate</button></div>
              </div>

            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer text-right">
        <button class="btn btn-submit" [disabled]="!(authcodeForm.valid && validCaptcha=='valid')" *ngIf="showRequestVersionUpdate()" (click)="sendEmailAuthCodeRequestEmail(false)">Submit</button>
        <button class="btn btn-submit" [disabled]="!(authcodeForm.valid && validCaptcha=='valid')" *ngIf="!showRequestVersionUpdate()" (click)="sendEmailAuthCodeRequestEmail(true)">Submit</button>

      </div>
    </div>
  </div>
</div>
<gcs-loading-spinner [show]="isProgress" [opacity]="isProgress"></gcs-loading-spinner>
